// extracted by mini-css-extract-plugin
export default {"titleBlock":"xNr6P02ttWm8PsC1dk9O","title":"_d7GhBh5AAGrrUIysjHf","total":"jt6xWUHnidJZRcYMyTYo","description":"R6GYwkLhlnUYSd0ldDLT"};